import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import DashboardService from "src/apis/DashboardService";
import { toast } from "react-toastify";
import { withNamespaces } from "react-i18next";
import ColumnWithDataLabels from "../../../ColumnWithDataLabels";

const DashboardCaseTypes = ({ t, type, filters, modules }) => {
  const { data: dashboardData, isFetching: summaryIsFetching } = useQuery({
    queryKey: ["wb-cm-fetch-admin-dashboard-summary-query", filters],
    queryFn: async () => {
      const service = DashboardService.getInstance();
      return await service.fetchSummary(
        {
          ...filters,
          excludeDeleted: (filters.exclude || []).includes("deleted_cases"),
          excludeTestCases: (filters.exclude || []).includes("test_cases"),
          exclude: undefined,
        },
        modules?.active
      );
    },
    cacheTime: 0,
    refetchOnWindowFocus: false,
    onError: (error) => {
      if (process.env.NODE_ENV === "development") console.error(error);

      toast(t("An error occurred while fetching dashboard data."), {
        type: "error",
      });
    },
  });

  const listTypes = useMemo(() => {
    const result = {
      percents: [],
      titles: [],
    };
    const types = dashboardData?.types || {};

    for (const item in types) {
      result.percents.push(parseInt(types[item].percent));
      result.titles.push(t(types[item].title));
    }
    return result;
  }, [dashboardData?.types, t]);

  return (
    <ColumnWithDataLabels options={listTypes} isLoading={summaryIsFetching} />
  );
};

export default withNamespaces()(DashboardCaseTypes);
